/* eslint-disable no-restricted-imports */
import React, {useEffect} from 'react'
import {Button} from '../../../../common/Button/Button'
import styles from './ActionButtons.module.scss'
import {T} from '../../../../common/T'
import {useUIGameManagerContext} from '../../../../contexts/UIGameManagerContext'
import {createPortal} from 'react-dom'

export function OpenStatsButton({onOpenStatsClick}: {onOpenStatsClick: VoidFunction}) {
    const gameManager = useUIGameManagerContext()
    const openStatsButtonContainerRef = React.useRef<HTMLDivElement>(null)
    const resize = () => {
        const canvas = gameManager.canvasController
        if(openStatsButtonContainerRef.current) {
            const container = openStatsButtonContainerRef.current
            container.style.right = canvas.chatWidth + canvas.margin * 2 + 'px'
        }
        gameManager.replayView?.setPosition()
    }

    useEffect(() => {
        window.addEventListener('resize', resize)
        resize()

        return () => {
            window.removeEventListener('resize', resize)
        }
    }, [])

    return (
        <>
            {createPortal(<div
                className={styles.openStatsButtonContainer}
                ref={openStatsButtonContainerRef}
            >
                <Button
                    className={styles.openStatsButton}
                    onClick={onOpenStatsClick}
                    variant='dark'>
                    <T id={{key: 'strings:game.endGame.cornerButton.openStats'}}/>
                </Button>
            </div>, document.getElementById('ui-game') as HTMLElement)}
        </>
    )
}
